import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getPropList } from '@/api/activity'




export const usePropsStore = defineStore('props', () => {
  // 道具列表
  const propsList = ref([])
  const loading = ref(false)

  // 获取道具列表
  const getPropsList = async () => {
    if (propsList.value.length > 0) {
      return propsList.value
    }

    loading.value = true
    try {
      const res = await getPropList({
        page: 1,
        pageSize: 1000 // 获取1000条道具数据
      })

      if (res.code === 0 && res.data?.list) {
        propsList.value = res.data.list
      }
      return propsList.value
    } catch (error) {
      console.error('获取道具列表失败:', error)
      return []
    } finally {
      loading.value = false
    }
  }

  // 获取过滤的道具列表
  const getFilterPropsList = async (itemTypes = [], isTemplate = true) => {
    loading.value = true
    try {
      const params = {
        page: 1,
        pageSize: 1000 // 获取1000条道具数据
      }

      // 添加模板参数
      if (isTemplate !== undefined) {
        params.is_template = isTemplate
      }

      // 添加道具类型参数
      if (itemTypes && itemTypes.length > 0) {
        params.item_types = itemTypes
      }

      const res = await getPropList(params)

      if (res.code === 0 && res.data?.list) {
        return res.data.list
      }
      return []
    } catch (error) {
      console.error('获取过滤道具列表失败:', error)
      return []
    } finally {
      loading.value = false
    }
  }

  // 刷新道具列表
  const refreshPropsList = async () => {
    propsList.value = []
    return await getPropsList()
  }

  // 初始化道具数据
  const initPropsData = async () => {
    if (propsList.value.length === 0) {
      await getPropsList()
    }
  }

  // 根据道具ID获取道具名称
  const getPropName = (propId) => {
    const prop = propsList.value.find(p => p.id === propId)
    if (!prop?.i18n_content) {
      return `道具${propId}`
    }
    // i18n_content 是数组，需要找到 language = 'zh' 的项
    const zhContent = prop.i18n_content.find(item => item.language === 'zh')
    return zhContent?.item_name || `道具${propId}`
  }

  // 根据道具ID获取道具信息
  const getPropById = (propId) => {
    return propsList.value.find(p => p.id === propId)
  }

  // 获取指定类型的道具
  const getPropsByType = (type) => {
    return propsList.value.filter(prop => prop.type === type)
  }

  // 设置道具列表 (用于测试)
  const setPropsList = (list) => {
    propsList.value = list
  }

  return {
    propsList,
    loading,
    getPropsList,
    getFilterPropsList,
    refreshPropsList,
    initPropsData,
    getPropName,
    getPropById,
    getPropsByType,
    setPropsList
  }
}) 